import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 377 186",
  fill: "currentColor",
  preserveAspectRatio: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M0.5 185.5H376.5V32.4292C376.365 32.3716 376.185 32.2952 375.96 32.2011C375.4 31.9672 374.563 31.6235 373.458 31.1859C371.246 30.3105 367.957 29.059 363.656 27.5566C355.052 24.5519 342.396 20.544 326.194 16.5355C293.79 8.51848 247.209 0.5 190.511 0.5C131.801 0.5 84.2131 8.51888 51.3072 16.5359C34.8543 20.5444 22.0723 24.5524 13.4061 27.557C9.07308 29.0593 5.76905 30.3108 3.54967 31.1861C2.43999 31.6237 1.60147 31.9673 1.04108 32.2012C0.815503 32.2953 0.63499 32.3717 0.5 32.4293V185.5Z" }, null, -1)
  ])))
}
export default { render: render }